<mat-form-field class="example-full-width" appearance="outline">
  <mat-label>Папка</mat-label>
  <input matInput [formControl]="control" [matAutocomplete]="auto" />
  <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayProperty">
    <mat-option *ngFor="let folder of filteredOptions | async | async" [value]="folder">
      {{ folder.description }}
    </mat-option>
  </mat-autocomplete>
  <mat-icon matSuffix>folder</mat-icon>
</mat-form-field>
